import { adminServices } from "../../services/admin";
import { ActionTypes } from "../constants/actionTypes";
import { alertError } from "./alertActions";

export const adminActions = {
    getAllCompetitors,
    getAllCompetitorProducts,
    getAllResources,
    getAllResourceTypes,
    getAllProductTypes,
};

function getAllCompetitors(access) {
    return (dispatch) => {
        dispatch(request({}));
        adminServices
            .getAllCompetitors(access)
            .then((admin_competitors) => {
                dispatch(success(admin_competitors));
            })
            .catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
    };
    function request(user) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITORS_REQUEST, user };
    }
    function success(admin_competitors) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITORS_SUCCESS, admin_competitors };
    }
    function failure(error) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITORS_FAILURE, error };
    }
}

function getAllCompetitorProducts(access) {
    return (dispatch) => {
        dispatch(request({}));
        adminServices
            .getAllCompetitorProducts(access)
            .then((admin_competitor_products) => {
                dispatch(success(admin_competitor_products));
                //analyticsService.logCompetitiveEvent(access, LogCompetitiveEvents.DASHBOARD)
            })
            .catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
    };
    function request(user) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_REQUEST, user };
    }
    function success(admin_competitor_products) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_SUCCESS, admin_competitor_products };
    }
    function failure(error) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_FAILURE, error };
    }
}

function getAllResources(access) {
    return (dispatch) => {
        dispatch(request({}));
        adminServices
            .getAllResources(access)
            .then((admin_resources) => {
                dispatch(success(admin_resources));
                //analyticsService.logCompetitiveEvent(access, LogCompetitiveEvents.DASHBOARD)
            })
            .catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
    };
    function request(user) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_REQUEST, user };
    }
    function success(admin_resources) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_SUCCESS, admin_resources };
    }
    function failure(error) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_FAILURE, error };
    }
}

function getAllResourceTypes(access) {
    return (dispatch) => {
        dispatch(request({}));
        adminServices
            .getAllResourceTypes(access)
            .then((admin_resource_types) => {
                dispatch(success(admin_resource_types));
                //analyticsService.logCompetitiveEvent(access, LogCompetitiveEvents.DASHBOARD)
            })
            .catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
    };
    function request(user) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_REQUEST, user };
    }
    function success(admin_resource_types) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_SUCCESS, admin_resource_types };
    }
    function failure(error) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_FAILURE, error };
    }
}

function getAllProductTypes(access) {
    return (dispatch) => {
        dispatch(request({}));
        adminServices
            .getAllProductTypes(access)
            .then((admin_product_types) => {
                dispatch(success(admin_product_types));
                //analyticsService.logCompetitiveEvent(access, LogCompetitiveEvents.DASHBOARD)
            })
            .catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
    };
    function request(user) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_REQUEST, user };
    }
    function success(admin_product_types) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_SUCCESS, admin_product_types };
    }
    function failure(error) {
        return { type: ActionTypes.ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_FAILURE, error };
    }
}